import { DatasetDataType } from '@/types/schema';

export function createEmptyOutput(dataType: DatasetDataType) {
  if (dataType === 'kv') {
    return null;
  }
  if (dataType === 'llm') {
    return { output: '' };
  }
  if (dataType === 'chat') {
    return { output: { type: '', data: { content: '' } } };
  }
}
